
































































import { defineComponent, ref, toRefs, computed, reactive, watch } from '@vue/composition-api';
import { HelpCircleIcon } from 'tdesign-icons-vue';
import { formatSize, formatSize2Byte } from '@/renderer/scripts/utils/tools/index';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
export default defineComponent({
  components: {
    HelpCircleIcon,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    spaceInfo: {
      required: true,
      type: Object,
      default: {
        id: -1,
        capacity: '0',
        size: '0',
      },
    },
    spaceType: {
      required: true,
      type: String,
      default: 'teamSpace',
    },
  },
  setup(props, context) {
    const store = context.root.$store;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const { sizeMap } = ConstantConfig;
    const sizeOptions = Object.keys(sizeMap).map(key => ({
      label: key,
      value: key,
    }));

    // 团队空间大小选项 'shared' | 'customed'
    const spaceConfig = ref('shared');
    const orgSpaceSize = ref('-1');
    const orgSpace = ref('');
    const { spaceInfo, spaceType } = toRefs(props);
    const usedInfo = reactive({
      size: '0',
      unit: 'B',
    });
    const size = ref('0');
    const unit = ref('B');
    const sizeIsNull = computed(() => !size.value || size.value === '0');
    const currSize = computed(() => formatSize2Byte(size.value, unit.value));
    const usedNum = computed(() => +spaceInfo.value.size);
    const spaceConfigChanged = computed(() => {
      const initSpaceConfig = spaceInfo.value.capacity === null ? 'shared' : 'customed';
      return initSpaceConfig !== spaceConfig.value;
    });
    const sizeChanged = computed(() => {
      const currNum = formatSize2Byte(size.value, unit.value);
      const initNum = spaceInfo.value.capacity;
      const changed = +initNum !== +currNum || spaceConfigChanged.value;
      return changed;
    });
    // 当前输入的空间大于企业剩余空间大小
    const currSizeMoreThanOrgSize = computed(() => +orgSpaceSize.value > -1 && currSize.value > +orgSpaceSize.value);
    // 当前输入的空间小于自身已使用大小
    const currSizeLessThanUsedSize = computed(() => currSize.value < usedNum.value);
    const sizeDisabled = computed(() => {
      if (!sizeChanged.value) return sizeIsNull.value;
      return (
        spaceConfig.value === 'customed' &&
        (sizeIsNull.value || currSizeLessThanUsedSize.value || currSizeMoreThanOrgSize.value)
      );
    });
    const saveDiabled = computed(() => !sizeChanged.value || (sizeChanged.value && sizeDisabled.value));
    const methods = {
      // 查询组织配额
      async getOrgSpaceInfo(currentQutoa: number) {
        try {
          const { availableSpace } = await store.dispatch('GetOrgSpace');
          const realAvaQutoa = +availableSpace + currentQutoa; // 可用配额 = 剩余的配额 + 用户当前配额
          orgSpaceSize.value = `${realAvaQutoa}`;
          const sizeInfo = formatSize(orgSpaceSize.value);
          orgSpace.value = `${sizeInfo.size}${sizeInfo.unit}`;
        } catch (e) {
          orgSpaceSize.value = '0';
          orgSpace.value = '0MB';
        }
      },
      // 保存配置
      onConfirm() {
        const capacity = spaceConfig.value === 'shared' ? null : `${formatSize2Byte(size.value, unit.value)}`;
        context.emit('submit', {
          spaceType: spaceType.value,
          id: spaceInfo.value.id,
          capacity,
        });
      },
    };
    watch(size, val => {
      size.value = `${val}`.replace(/\D/g, '');
    });
    watch(innerShow, val => {
      if (val) {
        Object.assign(usedInfo, {
          size: formatSize(spaceInfo.value.size).size,
          unit: formatSize(spaceInfo.value.size).unit,
        });
        const realSize = spaceInfo.value.shareLibraryRemainingQuota
          ? spaceInfo.value.availableSpace
          : spaceInfo.value.capacity;
        size.value = `${formatSize(realSize || ConstantConfig.defaultTeamSpaceSize, true).size}`;
        unit.value = formatSize(realSize || ConstantConfig.defaultTeamSpaceSize, true).unit;
        const itemCapacity = spaceInfo.value.shareLibraryRemainingQuota ? '0' : spaceInfo.value.capacity;
        methods.getOrgSpaceInfo(+itemCapacity || 0);
        spaceConfig.value = spaceInfo.value.shareLibraryRemainingQuota ? 'shared' : 'customed';
      }
    });
    return {
      innerShow,
      sizeOptions,
      usedInfo,
      size,
      unit,
      orgSpace,
      spaceConfig,
      currSizeMoreThanOrgSize,
      currSizeLessThanUsedSize,
      sizeDisabled,
      saveDiabled,
      ...methods,
    };
  },
});
